import { MutateOptions } from '@tanstack/react-query';
import { PractitionerData } from 'api/httpEntities';
import { InviteUserDataV2 } from 'api/practitioners/practitionerApiTypes';
import { LicensedProduct, Role } from 'types/types';

export const ROLE_MAP: RoleMapType = {
  CLIENT_SERVICES: 'SUPER_ADMIN',
  GROUP_MANAGER: 'GROUP_MANAGER',
  ADVANCED_USER: 'ADVANCED_USER',
  STANDARD: 'STANDARD',
  RESTRICTED_USER: 'RESTRICTED_USER',
};
export interface FormData extends InviteUserDataV2 {
  id?: string;
  licensedProducts: LicensedProduct[];
}

type PermissionRoleMapType = Record<Role, PermissionRole>;
export const PERMISSION_ROLE_MAP: PermissionRoleMapType = Object.fromEntries(
  Object.entries(ROLE_MAP).map(([k, v]) => [v, k]),
) as PermissionRoleMapType;

export type PermissionRole =
  | 'CLIENT_SERVICES'
  | 'STANDARD'
  | 'RESTRICTED_USER'
  | 'GROUP_MANAGER'
  | 'ADVANCED_USER';

export type RoleMapType = Record<PermissionRole, Role>;

export type AddUserFormProps = {
  mutate: (data: FormData, config: MutateOptions<any, any, any>) => void;
  resetMutation: (existingPractitioner?: boolean) => void;
  inviteUserError: any;
  isInviteUserError: boolean;
  currentOrgId: string;
  currentGroupId: string;
  initialPractitioner?: PractitionerData;
};
